<template>
  <div class="news flex">
    <div class="left">
      <div class="title">
        高考新闻
      </div>
      <ul>
        <li v-for="(item,index) in data" :key="index" @click="jump1(item)">
          {{item.title}}
        </li>

      </ul>
    </div>
    <div class="right">
      <div class="focus">
        考生关注
      </div>
      <div v-for="(item,index) in focus" :key="index">
        <span class="month">{{item.title}}</span>
        <ul>
          <li v-html="item.content"></li>

        </ul>
      </div>

    </div>
  </div>
</template>

<script>
  import {
    jump
  } from '../../../static/function.js'
  export default {
    data() {
      return {
        data: [],
        focus: []
      }
    },
    created() {
      this.$http.banner({
        cate_id: 5
      }).then(res => {
        this.data = res.data.list
      })
      this.$http.banner({
        cate_id: 10
      }).then(res => {
        this.focus = res.data.list
      })
    },
    methods: {
      jump1(item) {
        if (item.type_zn == '公众号') {
          window.open(item.content + '')
        } else {
          this.$router.push(`xinxiDetail?id=${item.id}`)
        }

      }
    }
  }
</script>

<style scoped lang="scss">
  .right {
    width: 334px;
    height: 350px;
    background: #FFFFFF;

    .focus {
      width: 331px;
      height: 55px;
      background: #C10B17;
      line-height: 55px;
      font-size: 27px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #FFFFFF;
      text-align: center;
    }

    &>div {
      text-align: left;
    }

    ul {
      text-align: left;
      margin: 0 16px;
    }

    ul li {
      // width: 32%;
      margin: 3px 0;
      display: inline-block;
      cursor: pointer;
    }

    .month {
      width: 50px;
      height: 24px;
      background: #C10B17;
      border-radius: 12px;
      display: inline-block;
      color: #FFFFFF;
      line-height: 24px;
      text-align: center;

      margin: 16px;
    }
  }

  .left {
    width: 903px;
    height: 350px;
    margin: 10px;
    box-shadow: 0px 0px 11px 5px rgba(0, 0, 0, 0.04);

    ul {
      text-align: left;
      margin: 16px;
    }

    .title {
      margin: 16px;
    }

    ul li {
      width: 50%;
      margin: 16px 0;
      display: inline-block;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      cursor: pointer;
    }
  }

  .news {
    width: 1280px;
    margin: 0 auto;
    justify-content: space-between;
    overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/components/index/news.vue